import React, { useState } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Box,
} from "@mui/material";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import LinkIcon from "@mui/icons-material/Link";
import TextFieldsIcon from "@mui/icons-material/TextFields";

interface Props {
  onFormat: (format: string, value?: any) => void;
  onInsertLink: () => void;
}

const MUITextEditorToolbar: React.FC<Props> = ({ onFormat, onInsertLink }) => {
  const [size, setSize] = useState<string | null>(null);

  const handleSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    newSize: string | null
  ) => {
    setSize(newSize);
    onFormat("size", newSize);
  };

  return (
    <Box sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center"}}>
      <ToggleButtonGroup 
        exclusive 
        size="small" 
        value={size}
        onChange={handleSizeChange}
      >
        <ToggleButton value="bold" onClick={() => onFormat("bold")} size="small" sx={{
          width:'35px'
        }}>
          <Tooltip title="Bold">
            <FormatBoldIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="italic" onClick={() => onFormat("italic")} size="small" sx={{
          width:'35px'
        }}>
          <Tooltip title="Italic">
            <FormatItalicIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="link" onClick={onInsertLink} size="small" sx={{
          width:'35px'
        }}>
          <Tooltip title="Inserisci Link">
            <LinkIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="small" sx={{
          width:'35px'
        }}>A-</ToggleButton>
        <ToggleButton value={false} sx={{
          width:'35px'
        }}>A</ToggleButton>
        <ToggleButton value="large" sx={{
          width:'35px'
        }}>A+</ToggleButton>
      </ToggleButtonGroup>

      
    </Box>
  );
};

export default MUITextEditorToolbar;
